import { render } from "./DashboardTopQuotes.vue?vue&type=template&id=26b102dd&ts=true"
import script from "./DashboardTopQuotes.vue?vue&type=script&lang=ts"
export * from "./DashboardTopQuotes.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__